import { createSlice } from '@reduxjs/toolkit';
import { ClientState } from './clientTypes';
import { createClient, updateClient, deleteClient, fetchClientById, fetchAllClients, fetchClientSummary ,fetchVendorSummary} from './clientAction';

const initialState: ClientState = {
    clients: [],
    clientSummary: [],
    VendorSummary: [],
    selectedClient: undefined,
    loading: false,
    error: undefined,
};

const clientSlice = createSlice({
    name: 'clients',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Client
            .addCase(createClient.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(createClient.fulfilled, (state, action) => {
                state.loading = false;
                state.clients.push(action.payload);
            })
            .addCase(createClient.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Update Client
            .addCase(updateClient.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(updateClient.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.clients.findIndex(client => client.Id === action.payload.Id);
                if (index !== -1) {
                    state.clients[index] = action.payload;
                }
            })
            .addCase(updateClient.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Delete Client
            .addCase(deleteClient.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(deleteClient.fulfilled, (state, action) => {
                state.loading = false;
                state.clients = state.clients.filter(client => client.Id !== action.meta.arg.clientId);
            })
            .addCase(deleteClient.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch Client by ID
            .addCase(fetchClientById.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchClientById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedClient = action.payload;
            })
            .addCase(fetchClientById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch All Clients
            .addCase(fetchAllClients.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchAllClients.fulfilled, (state, action) => {
                state.loading = false;
                state.clients = action.payload.data;
            })
            .addCase(fetchAllClients.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // Fetch All Summary
            .addCase(fetchClientSummary.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchClientSummary.fulfilled, (state, action) => {
                state.loading = false;
                state.clientSummary = action.payload.data;
            })
            .addCase(fetchClientSummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            .addCase(fetchVendorSummary.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchVendorSummary.fulfilled, (state, action) => {
                state.loading = false;
                state.VendorSummary = action.payload.data;
            })
            .addCase(fetchVendorSummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default clientSlice.reducer;
